import { useState } from 'react';
import type { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { ParentalControlsHeader } from '../../shared/ParentalControlHeader/ParentalControlsHeader';
import { Button } from '../../../Button/Button';
import { PinInputs } from '../../shared/PinInputs/PinInputs';

import * as styles from './DisableParentalControls.module.scss';

interface DisableParentalControlProps {
  code?: string;
  handleClose: () => void;
  handleDisable: () => void;
}

const DisableParentalControls: FC<DisableParentalControlProps> = ({
  code,
  handleClose,
  handleDisable,
}) => {
  const { t } = useTranslation();
  const [isActivationCodeCorrect, setIsActivationCodeCorrect] = useState(false);

  return (
    <>
      <ParentalControlsHeader
        titleText={t('Remove parental controls')}
        subtitleText={t('Enter your code to remove parental controls')}
      />
      <PinInputs
        codeToValidate={code}
        checkPinCorrection={setIsActivationCodeCorrect}
      />
      <Button
        variant="contained"
        size="medium"
        active={isActivationCodeCorrect}
        className={styles.button}
        disabled={!isActivationCodeCorrect}
        onClick={handleDisable}
      >
        {t('Confirm and remove')}
      </Button>
      <Button
        variant="contained"
        size="medium"
        className={styles.button}
        onClick={handleClose}
      >
        {t('cancel')}
      </Button>
    </>
  );
};

export { DisableParentalControls };
